import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Migrating to Webpack 2: some tips and gotchas",
  "description": "",
  "published": "2017-01-11T00:00:00.000Z",
  "redirect_from": ["/blog/using-webpack-2-production/swizec/7356"],
  "categories": "Front End, Technical, Webpack",
  "hero": "./img/1hh3ii.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`<`}{`tweet gone missing>`}</p>
    <p>{`Webpack 2.2 has reached `}<a parentName="p" {...{
        "href": "https://github.com/webpack/webpack/releases/tag/v2.2.0-rc.4"
      }}>{`release candidate 4`}</a>{`, the last pre-release version. Time to update!`}</p>
    <p>{`My motivation was `}<em parentName="p">{`"Ugh, I'm tired of these 3min+ local compile times. The amount of waiting is too damn high!"`}</em>{` The new features are a nice bonus too.`}</p>
    <p><a parentName="p" {...{
        "href": "https://imgflip.com/i/1hh3ii"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "420px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75.33632286995517%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'301\\'%20viewBox=\\'0%200%20400%20301\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20151v150h81v-3l1-2v5h172l9-5%209-4h23v9h106V0H0v151M125%207c-4%202-5%205-5%2016s0%2011%203%2014c4%204%2011%204%2015%200%203-4%203-24%200-28-3-2-9-4-13-2m92%200c-5%202-5%204-5%2016%200%2013%200%2014%204%2016%205%202%2011%201%2014-3V10c-2-3-10-5-13-3m160%200c-5%202-5%204-5%2017%200%2012%200%2012%203%2014%202%202%207%203%208%201h9l-1-9v-9h-11l1-5c0-4%200-4%201-1v4h5c5%200%205%200%203-8%200-4-9-6-13-4M6%2011c0%203%200%203%203%203h2v25h9V27c0-12%200-13%202-13s2-1%202-3V7H6v4m20%2012v16h9v-6l1-7%201%207v6h9V7h-9v6l-1%205-1-5V7h-9v16m22%200v16h15v-3c0-4%200-4-3-4s-3%200-3-3%200-3%203-3c2%200%202%200%202-3%200-4%200-4-2-4-4%200-4-5%200-5%202%200%203-1%203-4V7H48v16M74%207a2123%202123%200%2001-4%2032h5l5-1v-3c0-3%202-2%202%201v3h18v-6c0-6%201-6%201%201%201%205%201%205%204%205s3%200%204-6l1-5v11h8V7h-12v4l-1%204-1-4V7H92v14l-1%2013-1-3-2-13-1-11H74m68%2013c0%2017%201%2019%209%2020%204%200%205%200%208-3l3-3V7h-9v13l-1%2013-1-13V7h-9v13m22%203v16h8v-4c-1-6%200-6%202%200%201%204%201%204%205%204h5V7h-9v4c1%206%200%206-2%200-1-4-1-4-5-4h-4v16m21-12c0%203%200%203%203%203h2v25h9V27c0-12%200-13%202-13s2-1%203-4V7h-19v4m49-4v31l5%201h4v-6c0-7%200-7%203-7%202%200%202%200%202-3%200-4%200-4-2-4s-3%200-3-2%201-3%203-3%202%200%202-3V7h-14m21%201l2%2016%201%2015h12v-3c0-7%202-9%202-3l1%206h12l1-10%202-16V7h-9l-1%207-1%205-1-8V7h-4c-5%200-6%201-6%209%200%203%200%204-1%203l-1-7V7h-4l-5%201m35%2012l-3%2016c0%203%200%203%204%203%205%200%205%200%206-3l1-3%201%203v3h19V7h-9v14l-1%2014-2-11-2-14V7h-13l-1%2013m29-9c0%203%200%203%203%203h2v25h9V27c0-13%200-13%202-13s3-1%203-4V7h-19v4m20%2012v16h10l-1-16V7h-9v16m12%200v16h7v-5l1-5%201%205c2%205%202%205%206%205h4V7h-8v10l-2-5c-1-5-2-5-5-5h-4v16M244%2043h-6c-4%201-5%202-7%204l-4%204-3%203-2%204-2%206-1%204-1%202-3%203c-3%201-3%207-1%208h3l-1-1c-2%200-1-2%201-4s3-2%205-2h5c2%203%204%202%205%200%201-3%203-4%203-1%200%202%203%203%205%201l2-1-1%202c-1%201-1%201%201%201s2%201%202%203l1%202c2-1%202-4%200-6-1-2-1-2%201-5l2-1%202-1%202-3%202-1c2%200%204-2%204-5l3-3%202-1c1-1%201-1%207%202%202%201%205%200%204-2l-5-3-5-3c0-3-16-8-20-6M41%2057c-3%202-6%209-6%2013l-2%203c-2%200-3%202-1%202l1%202c-1%202-1%201%2017%204%2010%201%2026%200%2028-3%203-3%203-5%200-5-3%201-15-1-21-5-8-3-12-7-12-11%201-3-1-3-4%200m154%2040c-8%2010-10%2023-5%2027%201%202%203%203%203%202l3-1c4%200%2010-4%2012-7%202-4%208-5%2011-2%202%202%205%203%204%201v-1l1%201%202%201%204%202%202%201%201-1%201%202%201%203%202%203%204%203%202%202%204%201%203%201%2013%204c5%200%208-2%208-5l2-3%201-4%201-3-1-1c-2-1-2-1-1-2s2-2%201-3-1-1-2%201l-1%201c0-3-2-2-3%202l-1%203-1%202-2%203-2%201c0%202%200%202-1%201-2-2-5-2-5%200h-4c-2%201-7%200-6-1l-3-4-3-4c0-1-6-8-8-8-1%200-4-4-3-5%200-2-3-3-6-2h-4l-4%201-2%201-7%204c-3%203-4%204-7%204-7-1-8-4-4-14%202-6%202-9%200-7m16%2028l1%202c2%201%203%203%200%203-2%200-1%201%205%203%205%202%209%201%209-1l4-1c6%201%205-2-2-4-5-2-16-3-17-2m72%206l-1%206-2%207%201%203c2-1%204%202%204%205l1%202v4c2%201%202%202%200%203s-2%201-1%203h7c0%202%204%204%206%204l1-3c-1-3%201-2%203%202s4%204%204%200c0-3-2-5-7-9-7-6-10-10-11-13l-1-7v-8c1-2%201-2-1-2l-3%203m-92%203l-2%204c-3%205-3%207-3%2012s0%206%203%208l6%202c4%200%204%208%202%2026l-1%2012%2012-18c2-7%207-10%2011-9l4-1-3-1-6-2-4-1c-3%201-3%200-1-3l2-8c1-7%203-7%204%200l2%207c0%202%207%206%2011%206%202%200%203%202%204%207a2266%202266%200%20002%208l1%202-6%204c-4%201-7%202-7%204l-2%202c-2%200-3-2-2-3v-1c-3%200-3%203-1%205l2%201%201-1%201%206c0%206%200%206-2%207l-2%201c1%201%200%202-1%203l-2%203-1%203c-1%200%200%202%204%204l5%203%207-11a1481%201481%200%200135-62l-7%204-9%204c-6%203-8%203-6%200%203-6%204-12%201-16-2-4-5-5-12-3-6%202-7%202-7-2l-2-2-1-1-3-2c-3-1-3-1-6%202s-5%203-8-1c-2-3-5-4-8-2-2%201-2%201-3-1s-1-2-2%201M25%20269v20h10v-38l-5-1h-5v19m14-17c-2%202-2%204-2%208%200%205%203%209%2010%2014%202%202%203%203%203%205%200%204-2%203-3-1%200-3-1-4-5-4h-5v5c1%208%204%2010%2013%2010%208-1%2010-3%2010-11%200-6-1-8-7-12l-5-4v-5l1%202c0%203%202%204%206%204h4v-4c0-7-3-9-11-9-5%200-6%200-9%202m30-1c-1%204%201%208%203%208h3v15l1%2015h10v-30h3c2%200%203-1%203-5v-4H81l-12%201m27%202l-3%203v27l3%203c2%203%204%203%209%203%204%200%206%200%208-3l3-3v-27l-3-3c-2-3-4-3-8-3-5%200-7%200-9%203m26-1c-2%202-3%204-4%209%200%207%200%2020%202%2024%201%204%2014%206%2019%202%202-3%203-3%203-17v-14l-3-3c-4-4-13-5-17-1m32-1l-1%2020%201%2018h9c13%200%2013%200%2013-20%200-15%200-15-2-17-4-2-20-3-20-1m29%200l-3%2019c-3%2020-3%2019%203%2019%205%200%206-1%206-4%200-2%201-3%202-3l1%203c0%203%201%204%206%204s5%200%202-20l-3-18-7-1-7%201m21%2018l1%2020%204-1h4v-7l1-6v6c1%208%202%208%205%208s4-1%205-7l1-7v7c1%207%202%208%208%207l2-1v-37l-7-1c-8%200-8%200-8%208l-1%204-1-4c0-7-1-8-8-8h-6v19m34%200l1%2020h8v-7l1-6%201%205c2%208%202%208%2011%207l1-19v-18l-5-1c-4%200-5%200-4%2010%200%205-1%203-3-3l-2-7h-9v19m35-18l-1%2019v19h11v-8l1-8%201%208%201%208h9v-39h-10v7c0%209-2%209-2%200v-6l-5-1-5%201m26%2018l1%2020h9v-39h-10v19m16-16l-3%202v14c0%2017%201%2020%2011%2020l4-1h2l3%201c2%200%203-1%203-11v-10h-13v-4l1-5c0-4%202-2%202%202v4h10v-5c0-6-4-10-11-10-5%200-6%200-9%203m24%2016l1%2020%204-1h5v-7c1-10%203-10%203%200v8h10v-39h-5l-5%201a95%2095%200%2000-1%2011l-1%202-1-7v-7h-10v19m27-10l1%2015v5h4c4%200%204%200%204-4l1-14v-11h-11l1%209\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2eefbb455075bd1dba41b2d6d35366be/ca0a1/1hh3ii.webp 223w", "/static/2eefbb455075bd1dba41b2d6d35366be/ce09e/1hh3ii.webp 420w"],
                "sizes": "(max-width: 420px) 100vw, 420px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2eefbb455075bd1dba41b2d6d35366be/853b2/1hh3ii.jpg 223w", "/static/2eefbb455075bd1dba41b2d6d35366be/65f94/1hh3ii.jpg 420w"],
                "sizes": "(max-width: 420px) 100vw, 420px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/2eefbb455075bd1dba41b2d6d35366be/65f94/1hh3ii.jpg",
                "alt": "1hh3ii",
                "title": "made at imgflip.com",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`made at imgflip.com`}</figcaption>{`
  `}</figure></a></p>
    <p>{`After many days of fiddling, my Webpack is ready. Production compiles take 219 seconds instead of 226, and local dev compilation takes 152 seconds instead of 151. It’s not `}<em parentName="p">{`that`}</em>{` worth it, but incremental compiles with Webpack in `}<inlineCode parentName="p">{`watch`}</inlineCode>{` mode feel smooth as silk.`}</p>
    <p>{`I love the new feature that highlights big files and tells you initial load sizes for different apps. I’ve been using it to eyeball different options, and I'm sure it has bigger use cases, too. Fine-tuning code splitting perhaps?`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/01/Screen-Shot-2017-01-11-at-00.37.00.png",
        "alt": null
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/01/Screen-Shot-2017-01-11-at-00.38.28.png",
        "alt": null
      }}></img></p>
    <p>{`Then again, `}<inlineCode parentName="p">{`rc4`}</inlineCode>{` just disabled these features by default "because they're annoying". I liked it.`}</p>
    <p>{`Webpack recommends keeping files under 250kB, which sounds like a lot, but it looks damn small compared to my code. Did you know 196kB of source ES6 compiles into about 920kB of browser-ready JavaScript? `}<em parentName="p">{`With`}</em>{` minification, tree shaking, and dead code elimination! Without that, it's 2.3 megs. ?`}</p>
    <p>{`The day when we ship raw ES6 code can't come soon enough.`}</p>
    <p><em parentName="p">{`BTW: Tree shaking removes unused dependencies (like when you import a whole library but just use a function or two), and dead code elimination removes code that's unreachable, like functions you never call.`}</em></p>
    <p>{`So is upgrading to Webpack 2 even worth it?`}</p>
    <p>{`Totally. Once they and the ecosystem `}<a parentName="p" {...{
        "href": "https://github.com/webpack/webpack/issues/2867"
      }}>{`resolve some issues`}</a>{`, tree shaking will ride eternal, shiny and chrome.`}</p>
    <p>{`Here are some gotchas I discovered while upgrading.`}</p>
    <h2 {...{
      "id": "its-not-quiiiiite-ready-yet-dependency-hellish"
    }}>{`It's not quiiiiite ready yet (dependency hellish)`}</h2>
    <p>{`You can use Webpack 2 in production. I'm about to start.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}><a parentName="p" {...{
          "href": "https://twitter.com/TheLarkInn"
        }}>{`@TheLarkInn`}</a>{` in the midst of upgrading our prod app to Webpack2.`}<br parentName="p"></br><br parentName="p"></br>{`Prob going live within the week.`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/819004362231943168"
      }}>{`January 11, 2017`}</a></blockquote>
    <p>{`Although now that they’ve promised to release the final version in `}{`<`}{` 10 days, I might wait. Or gently delay the code review and QA process until their release. We'll see :)`}</p>
    <p>{`But here's one thing that's really awkward right now.`}</p>
    <p>{`When you upgrade to Webpack 2.2.rc.x, you fall into a small dependency hell with `}<inlineCode parentName="p">{`extract-text-webpack-plugin`}</inlineCode>{`. The released version depends on Webpack 2.1, which is silly. If you're going bleeding edge, you might as well go all the way, ya know?`}</p>
    <p>{`So here's what you have to do:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// packages.json
"dependencies": {
  //...
    "extract-text-webpack-plugin": "git://github.com/webpack/extract-text-webpack-plugin#cbd4690",
    "webpack": "^2.2.0-rc.3"
`}</code></pre>
    <p>{`I'd show you the `}<inlineCode parentName="p">{`npm install`}</inlineCode>{` command, but I don't know how to point at specific commits. See that `}<inlineCode parentName="p">{`#cbd4690`}</inlineCode>{` hash? That's the exact commit that says `}<inlineCode parentName="p">{`Add webpack 2 RC compatibility`}</inlineCode>{`.`}</p>
    <p>{`This is fragile and a terrible idea. You `}<em parentName="p">{`will`}</em>{` forget to update this dependency in the future, and it will continue to point at a random commit for the foreseeable future. Happens every time.`}</p>
    <p><em parentName="p">{`But`}</em>{` the published version on npm doesn't work. ? I assume they'll fix it for final release.`}</p>
    <p>{`Why extract-text-webpack-plugin? It makes stylesheet imports better, I'm told.`}</p>
    <blockquote>
      <p parentName="blockquote">{`It moves every require("style.css") in entry chunks into a separate css output file. So your styles are no longer inlined into the javascript, but separate in a CSS bundle file (styles.css). If your total stylesheet volume is big, it will be faster because the stylesheet bundle is loaded in parallel to the javascript bundle.`}</p>
    </blockquote>
    <p>{`See? Useful.`}</p>
    <p>{`You also have to update `}<inlineCode parentName="p">{`babel-loader`}</inlineCode>{` to at least `}<inlineCode parentName="p">{`6.2.10`}</inlineCode>{`. That's when they added support for Webpack 2 rc. Not too bad.`}</p>
    <h2 {...{
      "id": "funny-config-updates-but-better-docs"
    }}>{`Funny config updates, but better docs`}</h2>
    <p>{`The new Webpack 2 docs are `}<em parentName="p">{`so much better`}</em>{`. Check out this wonderful `}<a parentName="p" {...{
        "href": "https://webpack.js.org/guides/migrating/"
      }}>{`Migrating from v1 to v2`}</a>{` official guide. You basically have to do a find & replace, and you're done.`}</p>
    <p>{`Just don't forget to take `}<inlineCode parentName="p">{`''`}</inlineCode>{` out of `}<inlineCode parentName="p">{`resolve.extensions`}</inlineCode>{`. I don't remember why everyone needed that in the past, but I know that the new Webpack throws an error.`}</p>
    <p>{`Error reports for bad configuration are also better now. That was fun to see. Loved it.`}</p>
    <h2 {...{
      "id": "cssless-and-postcss-plugin"
    }}>{`CSS/Less and PostCSS plugin`}</h2>
    <p>{`If you're not using Webpack to load CSS and compile Less or Sass, you should. It's made my life a lot easier. Especially the `}<a parentName="p" {...{
        "href": "https://github.com/postcss/postcss"
      }}>{`PostCSS`}</a>{` plugin makes your CSS easier to write.`}</p>
    <p>{`Going from Webpack v1 to Webpack v2 involved many changes in this config. We used to have this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// webpack.config.js
loaders: [
    // ...
        {
        test: /\\.(less|css)$/,
        loader: ExtractTextPlugin.extract("style/useable", "css?sourceMap!postcss-loader!less-loader?sourceMap=true"),
        include: [
            path.resolve(__dirname, "app/assets/stylesheets")
        ]
    },

    {
        test: /\\.css$/,
        loader: ExtractTextPlugin.extract("style/useable", "css?sourceMap!postcss-loader?sourceMap=true")
    },
    // ...
],
postcss: function () {
    return [
        precss,

        // UglifyJSPlugin mangles valid css during minfication. It is a known issue and this fix was obtained from: https://github.com/webpack/webpack/issues/666#issuecomment-184319770
        postcssImport({ addDependencyTo: webpack }),
        postcssURL(),
        postcssNext({
            browsers: ['last 2 versions', 'ie >= 9'],
            compress: true
        }),
        cssnano({zindex: false})
            // end UglifyJSPlugin fix
    ];
}
`}</code></pre>
    <p>{`Which is probably too much config, but it worked. With Webpack v2 that's become more manageable and looks like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// webpack.config.js
    module: {
        rules: [
            {
                test: /\\.(less|css)$/,
                use: [
                    ExtractTextPlugin.extract({
                        fallbackLoader: "style/useable",
                        loader: "style-loader"
                    }),
                    {
                        loader: 'css-loader?sourceMap',
                        query: {
                            modules: true,
                            importLoaders: 2
                        }
                    },
                    'postcss-loader?sourceMap',
                    'less-loader?sourceMap'
                ]
            },
        ]
    },
`}</code></pre>
    <p>{`So much less code ?`}</p>
    <p>{`That's because a lot of it is now in a different file called `}<inlineCode parentName="p">{`postcss.config.js`}</inlineCode>{`. That one is a copypaste of the detailed config for postcss itself:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const webpack = require("webpack");

module.exports = {
  plugins: [
    // UglifyJSPlugin mangles valid css during minfication. It is a known issue and this fix was obtained from: https://github.com/webpack/webpack/issues/666#issuecomment-184319770
    require("postcss-import")({ addDependencyTo: webpack }),
    require("postcss-url"),
    require("postcss-cssnext")({
      browsers: ["last 2 versions", "ie >= 9"],
      compress: true,
    }),
    require("cssnano")({ zindex: false }),
    // end UglifyJSPlugin fix
  ],
};
`}</code></pre>
    <p>{`I don't know if the `}<inlineCode parentName="p">{`UglifyJS`}</inlineCode>{` bug we're working around still exists, so I left the config as I found it. Just to be safe.`}</p>
    <p>{`Looking at code blobs is hard, so here's what happened:`}</p>
    <ol>
      <li parentName="ol">{`Webpack 2 no longer allows plugin-specific config keys like `}<inlineCode parentName="li">{`postcss`}</inlineCode>{`. Everything must fit in the `}<inlineCode parentName="li">{`rules.use`}</inlineCode>{` listing.`}</li>
      <li parentName="ol">{`PostCSS now uses a separate config file called `}<inlineCode parentName="li">{`postcss.config.js`}</inlineCode>{`. This works out of the box.`}</li>
      <li parentName="ol">{`I removed separate rules for compiled and uncompiled CSS.`}</li>
      <li parentName="ol">{`Everything goes in the `}<inlineCode parentName="li">{`rules.use`}</inlineCode>{` array.`}</li>
      <li parentName="ol"><strong parentName="li">{`Use rules evaluate last to first.`}</strong></li>
      <li parentName="ol">{`First, we use `}<inlineCode parentName="li">{`less-loader`}</inlineCode>{` to compile Less to CSS.`}</li>
      <li parentName="ol">{`Then, we use `}<inlineCode parentName="li">{`postcss-loader`}</inlineCode>{` to do the PostCSS changes.`}</li>
      <li parentName="ol">{`Then, `}<inlineCode parentName="li">{`css-loader`}</inlineCode>{` enables `}<inlineCode parentName="li">{`import css from 'file.css'`}</inlineCode>{`.`}</li>
      <li parentName="ol">{`Finally, `}<inlineCode parentName="li">{`ExtractTextPlugin`}</inlineCode>{` puts it in `}<inlineCode parentName="li">{`<style>`}</inlineCode>{`.`}</li>
    </ol>
    <p>{`All of this used to be encoded in the loader bang syntax before: `}<inlineCode parentName="p">{`css?sourceMap!postcss-loader!less-loader?sourceMap=true`}</inlineCode></p>
    <p>{`Whomever came up with the `}<inlineCode parentName="p">{`use: []`}</inlineCode>{` syntax, you're the best. I love the new approach.`}</p>
    <h2 {...{
      "id": "tree-shaking-and-optimization"
    }}>{`Tree shaking and optimization`}</h2>
    <p>{`Now for the reason we're all here: tree shaking.`}</p>
    <p>{`Webpack 2 understands native ES6 imports and uses them as split points. That means it can organize your code into different chunks so you're only loading the JavaScript that you're using.`}</p>
    <p>{`What it `}<em parentName="p">{`also`}</em>{` means is that it understands when you're importing more than you need. Combined with the `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/package/webpack-uglify-js-plugin"
      }}>{`UglifyJsPlugin`}</a>{`, it can eliminate that extra code.`}</p>
    <p>{`I spent a lot of time looking for what exactly turns this feature on. Turns Out™, it's on by default. Just Works™.`}</p>
    <p>{`Here's what you have to do:`}</p>
    <ol>
      <li parentName="ol">{`Tell Babel `}<em parentName="li">{`not`}</em>{` to compile imports into CommonJS (require stuff)`}</li>
      <li parentName="ol">{`Enable UglifyJS`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// webpack.config.js
rules: [
  {
    test: /\\.js$/,
    include: [path.resolve(__dirname, "app/assets/javascripts")],
    exclude: [path.resolve(__dirname, "node_modules/")],
    query: {
      plugins: [
        "transform-decorators-legacy",
        "transform-runtime",
        "transform-object-rest-spread",
        "transform-react-constant-elements",
        "transform-class-properties",
      ],
      presets: [["es2015", { modules: false }], "latest", "react"],
    },
    loader: "babel-loader",
  },
];
// ...
plugins: [
  new webpack.optimize.UglifyJsPlugin({
    compress: {
      warnings: false,
      screw_ie8: true,
      conditionals: true,
      unused: true,
      comparisons: true,
      sequences: true,
      dead_code: true,
      evaluate: true,
      join_vars: true,
      if_return: true,
    },
    output: {
      comments: false,
    },
  }),
];
`}</code></pre>
    <p>{`See that `}<inlineCode parentName="p">{`{modules: false}`}</inlineCode>{` in the `}<inlineCode parentName="p">{`babel-loader`}</inlineCode>{` config? That's new. You can specify options when defining Babel plugins and presets.`}</p>
    <p><inlineCode parentName="p">{`modules: false`}</inlineCode>{` tells the `}<inlineCode parentName="p">{`es2015`}</inlineCode>{` preset to avoid compiling `}<inlineCode parentName="p">{`import`}</inlineCode>{` statements into CommonJS. That lets Webpack do tree shaking on your code.`}</p>
    <p>{`UglifyJsPlugin without extra config will do what we need, but I wanted to show you the options. It's `}<inlineCode parentName="p">{`unused`}</inlineCode>{` and `}<inlineCode parentName="p">{`dead_code`}</inlineCode>{` that enable tree shaking.`}</p>
    <p><strong parentName="p">{`However`}</strong>{`, we have to wait for the ecosystem to catch up. Most libraries are distributed with ES6 modules compiled to ES5, so in a real world scenario, `}<a parentName="p" {...{
        "href": "https://github.com/webpack/webpack/issues/2867#issuecomment-271802246"
      }}>{`you only get about 4% improvement`}</a>{`. ?`}</p>
    <p>{`With Webpack 2 around the corner, this is sure to improve. Can't wait!`}</p>
    <p>{`You should also split your code into Your Code and Everybody Else's code. Webpack docs have a great guide on `}<a parentName="p" {...{
        "href": "https://webpack.js.org/guides/code-splitting-libraries/"
      }}>{`Code Splitting for Libraries`}</a>{`.`}</p>
    <p>{`Happy hacking ?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      